import { css } from "../../../styled-system/css";

export const styles = {
  heading: () =>
    css({
      fontSize: "heading.H2.mobile",
      fontWeight: 400,
      lineHeight: "0.95",
      letterSpacing: "heading.H2",
      color: "ink",
      marginBottom: "baseUnit.mobile5",
      marginInline: "auto",
      maxWidth: "943px",
      desktop: {
        fontSize: "heading.H2.desktop",
      },
    }),

  wrapper: () =>
    css({
      width: "100%",
      marginInline: "auto",
      paddingInline: "baseUnit.mobile2",
      desktop: {
        paddingInline: 0,
        maxWidth: "1056px",
      },
    }),

  sliderWrapper: () =>
    css({
      position: "relative",
      "& .slick-track": {
        display: "flex",
        "&::before, &::after": {
          display: "none",
        },
      },
      "& .slick-slide": {
        height: "auto",
        float: "none",
        "& > div": {
          paddingInline: "baseUnit.mobile1",
          desktop: {
            paddingInline: "12px",
          },
        },
      },
      "& .slick-list": {
        overflow: "hidden",
        maskImage: "var(--slider-mask)",
        WebkitMaskImage: "var(--slider-mask)",
      },
    }),

  arrowsContainer: () =>
    css({
      display: "none",
      desktop: {
        display: "flex",
        gap: "baseUnit.mobile1",
        justifyContent: "flex-end",
        paddingRight: "baseUnit.mobile2",
        marginTop: "baseUnit.mobile2",
      },
    }),
};
